import React from 'react'
import { styles } from './Author.styles'
import UserInfo from '@components/UserInfo/amp'
import { publicUrl } from '@libs/appUrl'

export function Author(props) {
  const { url } = props
  const { name, mid, img } = props.userInfo

  return (
    <div className="author">
      <style jsx>{styles}</style>
      <UserInfo
        name={name}
        img={img}
        href={publicUrl(`/user/${mid}`)}
        loc={props.loc}
        locName={props.locName}
      />
      <a className="author__button" href={url}>
        ＋追蹤
      </a>
    </div>
  )
}

export default Author
